import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {YouthPlayer} from "@/modules/youth/entity";
import {Player, Team} from "@/modules/team/entity";
import {BeforeYouthPlayerTransferEvent} from "@/modules/youth/event/BeforeYouthPlayerTransferEvent";
import MarketValueCalculator from "@/modules/team/services/MarketValueCalculator";
import WageCalculator from "@/modules/team/services/WageCalculator";
import {AfterYouthPlayerTransferEvent} from "@/modules/youth/event/AfterYouthPlayerTransferEvent";

@injectable()
export class YouthPlayerTransferator {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(MarketValueCalculator) private marketValueCalculator: MarketValueCalculator,
    @inject(WageCalculator) private wageCalculator: WageCalculator,
  ) {}

  public async transfer(youthPlayer: YouthPlayer, team: Team) {
    await this.em.emitAsync(new BeforeYouthPlayerTransferEvent(youthPlayer));

    const player = new Player();
    player.skill = youthPlayer.skill;
    player.position = youthPlayer.position;
    player.talent = youthPlayer.talent;
    player.age = youthPlayer.age;
    player.name = youthPlayer.name;
    player.country = youthPlayer.country;
    player.patience = youthPlayer.patience;
    player.greediness = youthPlayer.greediness;
    player.resentfulness = youthPlayer.resentfulness;
    player.wage = this.wageCalculator.calculate(player);
    player.marketValue = await this.marketValueCalculator.calculate(player);
    player.team = team;
    player.contractYears = 3;
    player.revelation = 100;
    player.transferred = true;
    await player.save();

    await this.em.emitAsync(new AfterYouthPlayerTransferEvent(youthPlayer));
  }
}